module.exports = __webpack_public_path__ + "static/media/playstore.ab47b786.svg";